import { Component, computed, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogRef } from '@angular/material/dialog';
import { OfficeDataAccess } from '@data-access/office.data-acces';
import { House, LucideAngularModule } from 'lucide-angular';

export { OFFICE_KEY } from '@data-access/office.data-acces';

@Component({
  selector: 'offices',
  template: `
    <div class="p-6 border rounded-md max-w-[800px] min-w-[100px]">
      <h2 class="text-lg text-center mb-6">Elige tu sucursal</h2>
      <ul class="flex gap-8 justify-center flex-wrap">
        @for (office of offices(); track office) {
          <li
            class="flex flex-col items-center gap-4 cursor-pointer"
            (click)="chooseOffice(office.id)"
          >
            <button
              matButton="filled"
              class="!size-10 !min-w-auto rounded-full !p-0 items-center justify-center flex"
            >
              <lucide-angular size="16" [img]="house" />
            </button>
            <span class="text-sm text-center">{{ office.title }}</span>
          </li>
        }
      </ul>
    </div>
  `,
  imports: [LucideAngularModule, MatButtonModule],
})
export class OfficesDialog {
  readonly house = House;

  private dialogRef = inject(MatDialogRef);

  private officeDataAccess = inject(OfficeDataAccess);

  offices = computed(() => this.officeDataAccess.offices());

  chooseOffice(officeId: number): void {
    this.officeDataAccess.setSelectedOffice(officeId);

    this.dialogRef.close(officeId);
  }
}
